import AddUpdateItemUnitForm from 'components/Form/Tenant/ItemUnit/AddUpdateItemUnitForm';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

const ItemUnitFormPage: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  return (
    <div className="page-content">
      <Container fluid>
        <AddUpdateItemUnitForm id={id} />
      </Container>
    </div>
  );
};

export default ItemUnitFormPage;
